import { getSearchParams, safeWindow } from '@sky-distribution/gp-onboarding-shared-utils';

export const getReplacementUrlWithSearchParams = (
  searchParams: string[], params: [string, string][], basePath: string,
) => {
  const filteredParams = params.filter(([key]) => !searchParams.includes(key));
  const searchParamsStr = new URLSearchParams(filteredParams)
    .toString();

  return `${basePath}?${searchParamsStr}`;
};

export const clearSearchParams = (searchParams?: string[]) => {
  const params = Array.from(getSearchParams());
  const basePath = safeWindow()?.location?.pathname ?? '';
  const replacementUrl = searchParams ? getReplacementUrlWithSearchParams(searchParams, params, basePath) : basePath;

  safeWindow()?.history?.replaceState(null, '', replacementUrl);
};
